import './styles/ModalStyle.css';
import { useActions, useTypedSelector } from '../../hooks';
import { Button, Modal } from 'react-bootstrap';
import { languageMap } from '../../maps/languageMap';
import { navigationPages } from '../../models/types';
import { useHistory } from 'react-router-dom';

const EarlyExitModal: React.FC = () => {
  let history = useHistory();
  const showExitModal = useTypedSelector((state) => {
    return state.session.showExitModal;
  });
  const language = useTypedSelector((state) => {
    return state.session.language;
  });
  const { sessionExitShowModal } = useActions();
  const renderFooter = () => {
    return (
      <Modal.Footer>
        <Button
          onClick={() => sessionExitShowModal(false)}
          className="nav-button cancel-button"
        >
          {languageMap.shell.exit_session_cancel_button[language]}
        </Button>
        <Button
          onClick={() => {
            sessionExitShowModal(false);
            history.replace(`/${navigationPages.THANK_YOU}`);
          }}
          className="nav-button confirm-button"
        >
          {languageMap.shell.exit_session_confirm_button[language]}
        </Button>
      </Modal.Footer>
    );
  };
  return (
    <Modal
      show={showExitModal}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          {languageMap.shell.exit_session_message[language]}
        </Modal.Title>
      </Modal.Header>
      {renderFooter()}
    </Modal>
  );
};

export { EarlyExitModal };
